import React, { useState } from 'react';

interface EmiCalculatorProps {
  onClose: () => void;
}

const EmiCalculator: React.FC<EmiCalculatorProps> = ({ onClose }) => {
  const [principal, setPrincipal] = useState('');
  const [rate, setRate] = useState('');
  const [tenure, setTenure] = useState('');
  const [result, setResult] = useState<any>(null);

  const calculate = (e: React.FormEvent) => {
    e.preventDefault();
    const P = parseFloat(principal);
    const annualRate = parseFloat(rate);
    const n = parseInt(tenure);

    if (!P || !annualRate || !n) return;

    const r = annualRate / 12 / 100;
    const emi = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
    const totalPayable = emi * n;
    const totalInterest = totalPayable - P;

    setResult({ emi, totalPayable, totalInterest });
  };

  const fmt = (n: number) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);

  return (
    <div className="crm-modal-overlay" onClick={onClose}>
      <div className="crm-modal" style={{ maxWidth: '420px' }} onClick={e => e.stopPropagation()}>
        <div className="crm-modal-header">
          <h3>🧮 Loan EMI Calculator</h3>
          <button className="crm-modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={calculate} className="crm-modal-body">
          <div className="crm-modal-row">
            <label>Loan Amount (₹)</label>
            <input
              type="number"
              placeholder="e.g. 500000"
              value={principal}
              onChange={e => setPrincipal(e.target.value)}
              required
              style={{ padding: '9px 12px', border: '1.5px solid var(--crm-border)', borderRadius: 'var(--crm-radius-sm)', fontSize: '13.5px', fontFamily: 'Inter, sans-serif' }}
            />
          </div>
          <div className="crm-modal-row">
            <label>Annual Interest Rate (%)</label>
            <input
              type="number"
              step="0.01"
              placeholder="e.g. 9.5"
              value={rate}
              onChange={e => setRate(e.target.value)}
              required
              style={{ padding: '9px 12px', border: '1.5px solid var(--crm-border)', borderRadius: 'var(--crm-radius-sm)', fontSize: '13.5px', fontFamily: 'Inter, sans-serif' }}
            />
          </div>
          <div className="crm-modal-row">
            <label>Tenure (months)</label>
            <input
              type="number"
              placeholder="e.g. 60"
              value={tenure}
              onChange={e => setTenure(e.target.value)}
              required
              style={{ padding: '9px 12px', border: '1.5px solid var(--crm-border)', borderRadius: 'var(--crm-radius-sm)', fontSize: '13.5px', fontFamily: 'Inter, sans-serif' }}
            />
          </div>

          <button type="submit" className="crm-btn crm-btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
            Calculate EMI
          </button>
        </form>

        {result && (
          <div style={{ marginTop: 18, borderTop: '1px solid var(--crm-border)', paddingTop: 18 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
              <div style={{ textAlign: 'center', padding: '14px', background: 'var(--crm-primary-light)', borderRadius: '8px' }}>
                <div style={{ fontSize: '11px', color: 'var(--crm-primary)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Monthly EMI</div>
                <div style={{ fontSize: '20px', fontWeight: 800, color: 'var(--crm-primary)' }}>{fmt(result.emi)}</div>
              </div>
              <div style={{ textAlign: 'center', padding: '14px', background: 'var(--crm-success-light)', borderRadius: '8px' }}>
                <div style={{ fontSize: '11px', color: 'var(--crm-success)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Total Interest</div>
                <div style={{ fontSize: '18px', fontWeight: 800, color: 'var(--crm-success)' }}>{fmt(result.totalInterest)}</div>
              </div>
              <div style={{ textAlign: 'center', padding: '14px', background: 'var(--crm-warning-light)', borderRadius: '8px' }}>
                <div style={{ fontSize: '11px', color: '#92400E', fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Total Payable</div>
                <div style={{ fontSize: '18px', fontWeight: 800, color: '#92400E' }}>{fmt(result.totalPayable)}</div>
              </div>
            </div>
            <button className="crm-btn crm-btn-ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 12 }} onClick={() => setResult(null)}>
              Clear & Recalculate
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmiCalculator;
